import Hero from "@/components/home/Hero";
import RatesMarquee from "@/components/home/RatesMarquee";
import TrustRow from "@/components/home/TrustRow";
import SendWidget from "@/components/home/SendWidget";
import Manifesto from "@/components/home/Manifesto";
import CorridorMap from "@/components/home/CorridorMap";
import PayoutMethods from "@/components/home/PayoutMethods";
import Comparison from "@/components/home/Comparison";
import EditorialSpotlight from "@/components/home/EditorialSpotlight";
import SecurityBand from "@/components/home/SecurityBand";
import HandleShowcase from "@/components/home/HandleShowcase";
import Leaderboard from "@/components/home/Leaderboard";
import AppStorePreview from "@/components/home/AppStorePreview";
import QRInstall from "@/components/home/QRInstall";
import WaitlistCTA from "@/components/home/WaitlistCTA";
import AvailableCorridors from "@/components/home/AvailableCorridors";
import SEO from "@/components/SEO";

export default function HomePage() {
  return (
    <main data-testid="home-page">
      <SEO
        slug="home"
        title="Instantxfer CashApp — Send money between Africa and the world in minutes"
        description="The fastest, lowest-fee way to move money between Africa and the world. Mid-market rates, mobile money, cash pickup and scan-to-pay handles. Join the private beta."
      />
      <Hero />
      <TrustRow />
      <SendWidget />
      <RatesMarquee />
      <Manifesto />
      <CorridorMap />
      <PayoutMethods />
      <HandleShowcase />
      <Leaderboard />
      <Comparison />
      <EditorialSpotlight />
      <SecurityBand />
      <AppStorePreview />
      <QRInstall />
      <AvailableCorridors />
      <WaitlistCTA />
      <RatesMarquee variant="dark" />
    </main>
  );
}
